import { ReactElement, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CSSTransition } from 'react-transition-group';
import { PickerContent } from './PickerContent/PickerContent';
import { StyledButton, DropDownIcon, Wrapper } from './PickerField.styles';
import { PickerFieldProps } from './types';

export const PickerField = <T extends unknown>({
  button,
  leftIcon,
  selectedOption,
  options,
  onSelect,
}: PickerFieldProps<T>) => {
  const { i18n } = useTranslation();
  const [isActive, setIsActive] = useState(false);

  const handleClick = (newValue: T) => {
    setIsActive(!isActive);

    if (newValue !== selectedOption?.value) {
      onSelect?.(newValue);
    }
  };

  const pickerButton: ReactElement = button ?? (
    <StyledButton dir={i18n.dir()}>
      {leftIcon}
      {selectedOption?.label}
      <DropDownIcon />
    </StyledButton>
  );

  return (
    <Wrapper>
      <pickerButton.type
        {...pickerButton.props}
        onClick={() => setIsActive(!isActive)}
        role="combobox"
        aria-haspopup="listbox"
        aria-expanded={isActive}
      />
      <CSSTransition in={isActive} unmountOnExit timeout={0}>
        <PickerContent
          options={options}
          onClick={handleClick}
          isOpen={isActive}
          onDismiss={() => setIsActive(false)}
        />
      </CSSTransition>
    </Wrapper>
  );
};
